const loadScript = (src, position, id, onload) => {
    if (!position) {
        return;
    }
    const script = document.createElement("script");
    if (onload)
        script.onload = onload;
    script.setAttribute("async", "");
    script.setAttribute("id", id);
    script.src = src;
    position.appendChild(script);
};

export { loadScript };
